<template>
  <div class="PeriodSelector">
    <iv-select class="PeriodSelector__dimension" :value="dimension" @on-change="onDimensionChanged">
      <template v-for="item in options.DimensionOptions">
        <iv-option :key="item.id" :value="item.id">{{item.name}}</iv-option>
      </template>
    </iv-select>
    <template v-if="single">
      <div class="PeriodSelector__month" v-if="dimension==DIMENSION_TYPE_OF_MONTH">
        <iv-date-picker :value="singleData.value" :options="startOptions" type="month" @on-change="onChange('single', $event)"></iv-date-picker>
      </div>
      <div class="PeriodSelector__week" v-if="dimension==DIMENSION_TYPE_OF_WEEK">
        <iv-select :value="singleData.value" @on-change="onChange('single', $event)">
          <template v-for="item in periodList">
            <iv-option :key="item" :value="item">{{item}}</iv-option>
          </template>
        </iv-select>
      </div>
    </template>
    <template v-else>
      <div class="PeriodSelector__month" v-if="dimension==DIMENSION_TYPE_OF_MONTH">
        <iv-date-picker :value="start_at" type="month" :options="startOptions" @on-change="onChange('start', $event)"></iv-date-picker>
        <span> ~ </span>
        <iv-date-picker :value="end_at" type="month" :options="endOptions" @on-change="onChange('end', $event)"></iv-date-picker>
      </div>
      <div class="PeriodSelector__week" v-if="dimension==DIMENSION_TYPE_OF_WEEK">
        <iv-select :value="start_at" @on-change="onChange('start', $event)">
          <template v-for="item in periodList">
            <iv-option :key="item" :value="item">{{item}}</iv-option>
          </template>
        </iv-select>
        <span> ~ </span>
        <iv-select :value="end_at" @on-change="onChange('end', $event)">
          <template v-for="item in periodList">
            <iv-option :key="item" :value="item">{{item}}</iv-option>
          </template>
        </iv-select>
      </div>
    </template>
  </div>
</template>
<script>
export const DIMENSION_TYPE_OF_MONTH = 1
export const DIMENSION_TYPE_OF_WEEK = 2
export const DimensionOptions = [
  { id: DIMENSION_TYPE_OF_MONTH, name: '按月筛选' },
  { id: DIMENSION_TYPE_OF_WEEK, name: '按期筛选' },
]

function convertDaterang(dimension, val){
  let [start,end]=val // ['2023-01','2023-02'] or ['2023年11月 总第9期','2023年11月 总第8期']
  switch (dimension) {
    case DIMENSION_TYPE_OF_MONTH:
      // start = !!start ? fecha.parse(start, 'YYYY-mm') : ""
      // end = !!end ? fecha.parse(end, 'YYYY-mm') : ""
      break;
    case DIMENSION_TYPE_OF_WEEK:
      start = start
      end = end
      break;
  }
  return [start, end]
}

export default {
  name: 'PeriodSelector',
  model: {
    prop: 'value',
    event: 'changed'
  },
  props: {
    value: {
      type: Array,
      default: ()=>[]
    },
    dimension: {
      type: Number,
      default: DIMENSION_TYPE_OF_MONTH
    },
    startDisabledDate: {
      type: Function,
      default: ()=>false
    },
    endDisabledDate: {
      type: Function,
      default: ()=>false
    },
    single: Boolean,
    periodList: {
      type: Array,
      default: ()=>[]
    }
  },
  watch: {
    value(val, oldVal){
      if(val==oldVal) return;
      if(this.single){
        this.singleData.value = [...val].shift()
      }else{
        const [start_at, end_at] = convertDaterang(this.dimension, val)
        this.start_at = start_at
        this.end_at = end_at
      }
    },
    dimension(val, oldVal){
      if(this.single){
        this.singleData.value = ""
      }else{
        this.start_at = ""
        this.end_at = ""
      }
    }
  },
  data() {
    let start_at="", end_at="", singleVal="";
    if(this.single){
      singleVal = [...this.value].shift()
    }else{
      [start_at, end_at] = convertDaterang(this.dimension, this.value)
    }
    // const disabledDate = date => this.start_at && date.valueOf() <= fecha.parse(this.start_at, 'YYYY-mm').valueOf()
    return{
      DIMENSION_TYPE_OF_MONTH,
      DIMENSION_TYPE_OF_WEEK,
      start_at,
      end_at,
      options: {
        DimensionOptions
      },
      startOptions: {
        disabledDate: this.startDisabledDate,
      },
      endOptions: {
        disabledDate: this.endDisabledDate,
      },
      singleData:{
        value: singleVal
      }
    }
  },
  mounted(){
  },
  methods:{
    onChange(position, val){ //position: start or end
      if(position=='single'){
        this.singleData.value = val
        this.$emit('changed', [val])
      }else{
        this.$data[`${position}_at`] = val
        this.$nextTick(()=>{
          this.$emit('changed', [this.start_at, this.end_at])
        })
      }
    },
    onDimensionChanged(val){
      this.$emit('dimensionChanged', val)
    }
  },
}
</script>
<style lang="scss" scoped>
.PeriodSelector{
  display: flex;
  flex-direction: row;
  &__dimension{
    width: 100px;
    margin-right: 10px;
  }
  &__month{
    flex-grow: 1;
    .ivu-date-picker{
      width: 100px;
    }
  }
  &__week{
    flex-grow: 1;
    .ivu-select{
      display: inline-block;
      width: 160px;
    }
  }
}
</style>
